/* tslint:disable */
/* eslint-disable */
/**
 * Web MMB BFF API
 * Version of Backend for Frontend API (mid-layer between FE and MMB API) designed for web frontend purposes.
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { AlternativeSectorStopOriginalValuesFromJSON, AlternativeSectorStopOriginalValuesToJSON, } from './AlternativeSectorStopOriginalValues';
/**
 * Check if a given object implements the AlternativeSectorStop interface.
 */
export function instanceOfAlternativeSectorStop(value) {
    if (!('city' in value) || value['city'] === undefined)
        return false;
    return true;
}
export function AlternativeSectorStopFromJSON(json) {
    return AlternativeSectorStopFromJSONTyped(json, false);
}
export function AlternativeSectorStopFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'city': json['city'],
        'code': json['code'] == null ? undefined : json['code'],
        'datetimeLocal': json['datetime_local'] == null ? undefined : (new Date(json['datetime_local'])),
        'originalValues': json['original_values'] == null ? undefined : AlternativeSectorStopOriginalValuesFromJSON(json['original_values']),
    };
}
export function AlternativeSectorStopToJSON(json) {
    return AlternativeSectorStopToJSONTyped(json, false);
}
export function AlternativeSectorStopToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'city': value['city'],
        'code': value['code'],
        'datetime_local': value['datetimeLocal'] == null ? undefined : ((value['datetimeLocal']).toISOString()),
        'original_values': AlternativeSectorStopOriginalValuesToJSON(value['originalValues']),
    };
}
